import React from 'react';
import { connect } from 'react-redux';

import onlineUsersSelector from 'Selectors/onlineUsersSelector';
import { whoIsOnline, resetOnlineUsers } from 'Actions/OnlineUsersActions';
import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { trackPageView, onPageView } from 'Actions/adsActions';
import InfiniteScroll from 'Components/infiniteScroll/InfiniteScrollComponent';
import OnlineUsersListComponent from 'Components/onlineusers/OnlineUsersListComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

export class OnlineViewComponent extends React.Component {

	constructor( props ) {
		super( props );
		this.state = {
			headerHeight: 0
		};
	}

	get onlineUsers() {
		const { entities: { online }, result } = this.props.onlineUsers;
		return result.online.filter( user => online[ user ].userName !== 'Guest' );
	}

	componentWillMount() {
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetOnlineUsers() );
	}

	componentDidMount() {
		this.repositionScroll();
		let page = this.props.location.query.page || 1;
		this.loadPage( page );
	}

	componentWillUnmount() {
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetOnlineUsers() );
	}

	componentWillReceiveProps(nextProps) {
		if( nextProps.onlineUsers.loaded && nextProps.onlineUsers.loaded !== this.props.onlineUsers.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	componentDidUpdate() {
		this.repositionScroll();
	}

	repositionScroll = () => {
		if( this.header ) {
			let headerDim = this.header.getBoundingClientRect();

			if( headerDim.height && headerDim.height !== this.state.headerHeight ) {
				this.setState( { headerHeight: headerDim.height } );
			}
		}
	};

	onlineUsersList = () => {
		const { isFetching } = this.props.onlineUsers;
		if( this.onlineUsers.length !== 0 ) {
			return (
				<InfiniteScroll
					scrollRef={ i => this.infiniteScroll = i }
					isFetching={ isFetching }
					loadPage={ this.loadPage }
					location={ this.props.location }
					extraHeaderHeight={ this.state.headerHeight }
				>
					<OnlineUsersListComponent />
				</InfiniteScroll>
			)
		} else {
			return <div>No registered user online</div>
		}
	};

	loadPage = ( pageNum ) => {
		this.props.dispatch( whoIsOnline( pageNum ) );
	};

	_getHeather() {
		return (
			<header className="thread" ref={ ( h ) => this.header = h }>
				<div className="right">
					<ul className="stats">
						<li><span>Members Online</span> <span>{ this.props.onlineUsers.totals.members || '-' }</span></li>
						<li><span>Guests Online</span> <span>{ this.props.onlineUsers.totals.guests || '-' }</span></li>
					</ul>
				</div>
			</header>
		);
	}

	render() {
		if( !this.props.onlineUsers.loaded ) {
			return <div id='onlineUsers'>{ this._getHeather() }<LoaderCss style={ { marginTop: this.state.headerHeight + 'px' } } /></div>;
		}

		return (
			<div id='onlineUsers'>
				{ this._getHeather() }
				{ this.onlineUsersList() }
			</div>
		);
	}
}

export default connect( onlineUsersSelector )( OnlineViewComponent );



// WEBPACK FOOTER //
// ./src/components/OnlineViewComponent.js